import { render, staticRenderFns } from "./EbookButton.vue?vue&type=template&id=11a923ce"
import script from "./EbookButton.vue?vue&type=script&lang=js"
export * from "./EbookButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports